const config = {
  supportedLocales: {
    fr: "Français",
    de: "Deutsch",
  },
  poidsMaxImg: 512,
};

export default config;
